import { ReactNode, HTMLAttributes } from 'react';
import clsx from 'clsx';
import { FormLabel } from './FormLabel';
import { FormError } from './FormError';

export interface FormFieldProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  error?: string | string[];
  helperText?: string;
  required?: boolean;
  optional?: boolean;
  htmlFor?: string;
  children: ReactNode;
  fullWidth?: boolean;
}

export const FormField = ({
  label,
  error,
  helperText,
  required = false,
  optional = false,
  htmlFor,
  children,
  fullWidth = true,
  className,
  ...props
}: FormFieldProps) => {
  const hasError = !!error;

  return (
    <div
      className={clsx(
        'flex flex-col',
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {label && (
        <FormLabel
          htmlFor={htmlFor}
          required={required}
          optional={optional}
        >
          {label}
        </FormLabel>
      )}

      {children}

      {hasError && <FormError error={error} />}

      {!hasError && helperText && (
        <p className="mt-1.5 text-sm text-gray-500">
          {helperText}
        </p>
      )}
    </div>
  );
};
